package navigation.root.auth

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.authentication.domain.repository.AuthRepository
import com.essntl.features.authentication.ui.auth.AuthEvent
import com.essntl.features.authentication.ui.auth.AuthState
import com.essntl.features.authentication.ui.auth.AuthValidation
import com.essntl.features.authentication.ui.auth.AuthViewModel
import com.essntl.toastmanager.ToastManager

class AuthScreenModel(
    authRepository: AuthRepository,
    loadingManager: LoadingManager,
    toastManager: ToastManager,
) : StateScreenModel<AuthState>(AuthState()) {

    val validation = AuthValidation()

    private val authViewModel =
        AuthViewModel(
            scope = screenModelScope,
            state = mutableState,
            authRepository = authRepository,
            loadingManager = loadingManager,
            toastManager = toastManager,
        )

    fun onEvent(event: AuthEvent) = authViewModel.onEvent(event)

}